import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './components/forgot-password.component';

const routes: Routes = [{path: 'forgotpassword', component: ForgotPasswordComponent}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule],
  providers: []
})
export class ForgotPasswordRoutingModule {
}
